import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

//Style
import './BodyOilAndGas.css';

//Data
import dataInfoSection from '../../json/infoOilAndGasSection.json';
import data from '../../json/projectsOAGSection.json';
import dataClientOAG from '../../json/clientsOAG.json';

//Components
import PDCounterSection from "../PDCounterSection/PDCounterSection";
import InfoOilAndGasSection from "../InfoOilAndGasSection/InfoOilAndGasSection";
import PDProjectSection from "../PDProjectsSection/PDProjectSection";
import PDClientsSlide from "../PDClientsSlide/PDClientsSlide";

const BodyOilAndGas = () => {
  const location = useLocation();

  const useWindowWide = () => {
    const [width, setWidth] = useState(0);

    useEffect(() => {
      function handleResize() {
        setWidth(window.innerWidth);
      }

      window.addEventListener("resize", handleResize);

      handleResize();

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, [setWidth]);

    return width;
  };

  const wide = useWindowWide(767);

  return (
    <>
        <PDCounterSection location={location.pathname} video={true} />
        <div className="bg-pg"></div>
        <InfoOilAndGasSection info={dataInfoSection.data} />
        <PDProjectSection location={location.pathname} projects={data} />
        <PDClientsSlide wide={wide} clients={dataClientOAG} />
    </>
  );
};

export default BodyOilAndGas;
